import type { ReactNode } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { proNavigator } from "single-spa/react-app/ProNavigator";

import { StyledSignalCompanyLink } from "./styles";

type SignalCompanyLinkProps = {
    domain: string;
    children: ReactNode;
    onCompanyLinkClick: () => void;
};

const SignalCompanyLink = ({ domain, children, onCompanyLinkClick }: SignalCompanyLinkProps) => {
    const { state } = useCurrentStateAndParams();

    return (
        <StyledSignalCompanyLink
            href={proNavigator.href(state, {
                key: domain,
            })}
            target="_blank"
            rel="noreferrer"
            onMouseDown={onCompanyLinkClick}
        >
            {children}
        </StyledSignalCompanyLink>
    );
};

export default SignalCompanyLink;
